import { render } from "./UiPropVisibility.vue?vue&type=template&id=0a47c515"
import script from "./UiPropVisibility.vue?vue&type=script&lang=js"
export * from "./UiPropVisibility.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__